var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSwitchFilled = function SvgIconSwitchFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.533c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.139 13.477-2.5 1.498 2.5 1.502z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.35 13.104a.43.43 0 0 0-.431.006l-2.5 1.498a.428.428 0 0 0 0 .734l2.5 1.501a.428.428 0 0 0 .647-.366v-3a.43.43 0 0 0-.216-.373m-.639 1.128v1.489l-1.241-.745z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.86 14.977a.5.5 0 0 1-.5.5h-6.358a.5.5 0 1 1 0-1h6.357a.5.5 0 0 1 .5.5",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.828 11.531 2.5-1.498-2.5-1.502z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.617 11.903a.43.43 0 0 0 .431-.005l2.5-1.498a.428.428 0 0 0 0-.734l-2.5-1.501a.428.428 0 0 0-.648.366v3c0 .154.083.297.217.372m.639-1.127V9.287l1.24.745z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.197 10.031a.5.5 0 0 1 .5-.5h6.358a.5.5 0 0 1 0 1H7.697a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconSwitchFilled;